<template>
  <div>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="onShippingImportTemplateClick">
      {{ $t('Download Shipping Import Template') }}
    </b-dropdown-item>
    <b-dropdown-item @click="$refs.fileInput.click()">
      {{ $t('Upload Shipping Import Template') }}
    </b-dropdown-item>
    <input
      :multiple="false"
      @change="onInputChange"
      accept=".xls,.xlsx"
      type="file"
      class="d-none"
      ref="fileInput"
    />
  </div>
</template>

<script>
import InvoicesService from "@/modules/invoices/InvoicesService";
import {createNamespacedHelpers} from "vuex";
import {WS_BATCH_SHIPPING_IMPORT} from "@/modules/constants";
import {Formatter} from "@/core/services/formatter.service";

const {mapActions} = createNamespacedHelpers('invoices');
const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

export default {
  name: "InvoiceBatchShippingCharges",
  data() {
    return {
      progresses: {},
      file: null,
    }
  },
  methods: {
    ...mapActionsGlobal(['addProgress', 'removeProgress', 'updateProgressValue']),
    ...mapActions(['getTableData']),
    onShippingImportTemplateClick() {
      InvoicesService.downloadShippingImportTemplate();
    },
    clearInput() {
      this.$refs.fileInput.value = null;
    },
    async importData(confirmed = false) {
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('confirmed', confirmed);

      const response = await InvoicesService.uploadShippingImport(formData);
      if (response.success) {
        this.$toast('success', this.$i18n.t('Import Shipping Charges started'));
      } else if (response.body.non_field_errors) {
        this.$errorDialog(response.body.non_field_errors[0])
      }
    },
    async onInputChange(event) {
      const files = event.target.files;
      if (files.length === 0) return;

      this.file = files[0];
      await this.importData();
      this.clearInput();
    },
    async addProgressIfNotExist(id) {
      if (!this.progresses[id]) {
        const progressName = `${this.$i18n.t("Batch Shipping Fee Import")} - ${Formatter.toDateTime(new Date())}`;
        this.progresses[id] = await this.addProgress(progressName);
      }
    },
    removeProgressIfExist(id) {
      if (this.progresses[id]) {
        this.removeProgress(this.progresses[id].uuid);
        delete this.progresses[id];
      }
    },
    clearProgresses() {
      for (const key in this.progresses) {
        this.removeProgress(this.progresses[key].uuid);
      }
      this.progresses = {};
    },
    async onProgressNotificationReceive(data) {
      await this.addProgressIfNotExist(data.id)
      this.updateProgressValue({
        progressValue: parseInt(Math.round(data.successful / data.total * 100)),
        uuid: this.progresses[data.id].uuid
      });

      if (data.is_finished) {
        if (!data.errors) {
          this.$toast('success', this.$i18n.t("Import Shipping Charges has successfully completed"));
          this.getTableData();
        }
        this.removeProgressIfExist(data.id);
      }
      if (data.errors) this.handleProgressNotificationErrors(data);
    },
    async handleProgressNotificationErrors(data) {
      if (data.errors.non_field_errors) {
        this.$errorDialog(data.errors.non_field_errors[0])
      } else if (data.errors.errors) {
        const listItemsArr = [];
        data.errors.errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
        const title = this.$createElement('h5', {}, this.$i18n.t('Please enter correct value(s) on the following row(s):'));
        const errors = this.$createElement('ul', {class: "mb-0"}, listItemsArr);
        const message = this.$createElement('div', {}, [title, errors]);
        this.$errorDialog(message, this.$i18n.t('Validation Error'));
      } else if (data.errors.conflict_amount_invoices) {
        const htmlArr = [
          `<div>${this.$i18n.t('Invoices with Invoice No:')}</div>`,
          "<ul>",
          data.errors.conflict_amount_invoices.map(invoice => `<li>${invoice}</li>`).join(''),
          "</ul>",
          `<div>${this.$i18n.t('Already have shipping charges in Artisio, if you continue these charges will be overwritten with the ones in the file you are trying to upload.')}</div></br>`,
          `<div>${this.$i18n.t('Are you sure you would like to proceed?')}</div>`
        ]

        let success = await this.$confirm(htmlArr.join(''));
        if (success) this.importData(true);
      } else {
        this.$errorDialog(this.$i18n.t("Something went wrong while importing shipping charges. Please, try again later."))
      }
    },
  },
  mounted() {
    this.$ws.listen(`sales.${WS_BATCH_SHIPPING_IMPORT}`, this.onProgressNotificationReceive);
  },
  beforeDestroy() {
    this.clearProgresses();
    this.$ws.remove(`sales.${WS_BATCH_SHIPPING_IMPORT}`);
  },
}
</script>

<style scoped>
</style>
